module.exports = __webpack_public_path__ + "e40c68dbe8925590339113795c26bf72.png";